/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
class Product extends Core {
	constructor() {
		super();
		this.initializeElements();
		this.selectedVariant = null;
		this.selectedPot = "none";
		this.addOns = [];
		this.potSelectorModal = null;
		this.productType = document.querySelector("[data-product-type]").dataset.productType;
		this.productId = document.querySelector("form[data-product-id]").dataset.productId;
		this.selectedOptions = {};
	}

	initializeElements() {
		this.variantsForm = document.getElementById("variant-selector");
		this.variantInputs = Array.from(document.querySelectorAll('#variant-selector input[name="variant"]'));
		this.variantOptionsForm = document.getElementById("variant-options-form");
		this.productMediaContainer = document.getElementById("product-media-container");
		this.productMediaContainerCarousel = document.querySelector("#product-media-container-carousel [data-movable]");
		this.potSelectorContainer = document.getElementById("pot-selector-container");
		this.selectedPotContainer = document.getElementById("selected-pot-container");
		this.variantElements = Array.from(document.querySelectorAll("[data-variant]")); // stuff to show when variant is selected (addons..)
		this.variants = Array.from(document.querySelectorAll('input[name="variant"]'));
		this.addToBagBtn = document.getElementById("add-to-bag");
		this.backToStockContainer = document.querySelector("[data-back-in-stock]");
		this.giftVoucherFormContainer = document.getElementById("form-gift-voucher");
		this.numberOFVariants = Array.from(this.variantOptionsForm.querySelectorAll("ul li:first-child ul li")).length;
	}

	init() {
		// Add event listeners to option inputs
		const optionInputs = Array.from(this.variantOptionsForm.querySelectorAll('input[type="radio"]'));
		optionInputs.forEach((optionInput) => {
			optionInput.addEventListener("change", this.handleOptionChange.bind(this));
		});
		// Initially hide all option groups except the first one (Size)
		this.initializeOptionGroups();

		this.handleProductMediaContainer();
		this.handlePotSelectorModalTriggers();
		this.handleAddOns();
		this.addToBagBtn?.addEventListener("click", this.handleAddToBag.bind(this));
		this.checkSelectedVariantUrlParams();

		if (this.numberOFVariants === 1) {
			// Selects first option if it's the only option
			const group = this.variantOptionsForm.querySelector("li[data-group-name]");
			const option = group.querySelector("li");
			this.autoSelectFirstAvailable(group);
			if (option && option.getAttribute("data-value") === "Default Title") {
				group.classList.add("hidden");
			}
		}

		this.handleAllVariantsUnavailable();

		const backToStockForm = this.backToStockContainer.querySelector("form");
		backToStockForm.addEventListener("submit", this.handleBackToStock.bind(this));

		if (this.potSelectorContainer) {
			// show msg on click hover pots and no variant selected
			this.potSelectorContainer.addEventListener("click", () => {
				if (!this.selectedVariant) {
					// TODO, show message that they need select a variant first
				}
			});
		}
	}

	setupGiftVoucherForm(show) {
		if (!this.giftVoucherFormContainer) return;

		this.giftVoucherFormContainer.classList.toggle("hidden", !show);
		const sendAsGiftCb = this.giftVoucherFormContainer.querySelector("#send_as_gift");
		const giftFields = this.giftVoucherFormContainer.querySelector(".gift-fields");
		const giftEmailField = this.giftVoucherFormContainer.querySelector("#recipient_email");
		sendAsGiftCb.addEventListener("change", () => {
			giftFields.classList.toggle("hidden", !sendAsGiftCb.checked);
		});
		giftEmailField.addEventListener("click", () => {
			const gitfEmailEl = this.giftVoucherFormContainer.querySelector(".recipient-email");
			gitfEmailEl.classList.remove("border-warning");
		});
	}

	sendPDPEvents(event) {
		const payload = {};
		try {
			const productTitle = this.variantsForm.getAttribute("data-product-title");
			switch (event) {
				case "variant-selected":
					{
						const variantSelected = this.variantsForm.querySelector("input:checked");
						const { variantSelectedOptions, sku } = variantSelected.dataset;
						const variant = JSON.parse(variantSelectedOptions).map((opt) => opt.value);
						Object.assign(payload, {
							event: "PDP_variant_selected",
							properties: {
								product_name: productTitle,
								sku,
								variant_name: variant.join(" - "),
							},
						});
					}
					break;
				case "variant-oos":
					Object.assign(payload, {
						event: "PDP variant out of stock",
					});
					break;
				default:
					console.log("Event invalid");
					break;
			}
			if (payload.event) {
				window.RudderAnalytics.sendEvent({
					type: "track",
					payload,
				});
			}
		} catch (error) {
			console.log(error);
		}
	}

	// [START] Variant select functions

	handleAllVariantsUnavailable() {
		const variantsInputs = Array.from(this.variantsForm.querySelectorAll("input"));
		const hasAvailableVariant = variantsInputs.filter((vi) => vi.getAttribute("data-variant-available") === "true");
		if (hasAvailableVariant.length === 0) {
			this.toggleBackToStockForm(variantsInputs[0].value);
		}
	}

	initializeOptionGroups() {
		const optionGroups = this.variantOptionsForm.querySelectorAll("li[data-group-name]");
		optionGroups.forEach((group, index) => {
			this.updateAvailableOptions(group); // check if has at least one sub option available
			if (index !== 0) {
				const groupItems = group.querySelector("ul");
				groupItems.setAttribute("hidden", "hidden"); // Hide all groups except the first
			}
		});
	}

	// Handle option change
	handleOptionChange(event) {
		const optionName = event.target.getAttribute("data-option-name");
		const optionValue = event.target.value;

		// Add selected option value next to option title when needed
		this.addOptionValueToOptionTitle(optionName, optionValue);

		// Update the selected options
		this.selectedOptions[optionName] = optionValue;

		// Reset and update lower levels after changing the higher-level option
		this.resetLowerOptions(optionName);

		// Show the next group of options based on current selection
		this.showNextOptionGroup();

		// Try to match a variant
		this.matchVariant();
	}

	// Reset lower-level options when higher-level option changes
	resetLowerOptions(changedOptionName) {
		let foundChangedOption = false;
		const optionGroups = this.variantOptionsForm.querySelectorAll("li[data-group-name]");

		// Iterate through each group to reset lower levels
		optionGroups.forEach((group) => {
			const groupName = group.getAttribute("data-group-name");

			if (groupName === changedOptionName) {
				foundChangedOption = true;
			}

			if (foundChangedOption && groupName !== changedOptionName) {
				// Clear the selection for lower-level groups
				this.selectedOptions[groupName] = undefined;
				const groupInputs = group.querySelectorAll('input[type="radio"]');
				groupInputs.forEach((input) => {
					input.checked = false;
				});
			}
		});
	}

	// Show the next option group based on selected options
	showNextOptionGroup() {
		const optionGroups = this.variantOptionsForm.querySelectorAll("li[data-group-name]");
		let showNext = true;

		optionGroups.forEach((group) => {
			const groupName = group.getAttribute("data-group-name");
			const groupItems = group.querySelector("ul");
			if (this.selectedOptions[groupName] !== undefined) {
				groupItems.removeAttribute("hidden"); // Keep current level visible if selected
			} else if (showNext) {
				groupItems.removeAttribute("hidden"); // Show next unselected level
				this.updateAvailableOptions(group); // Update options in the next group based on previous selections
				this.autoSelectFirstAvailable(group); // Auto-select the first available option in the next level
				showNext = false; // Stop after showing the next available level
			} else {
				groupItems.setAttribute("hidden", "hidden"); // Hide future levels until this one is selected
			}
		});
	}

	// Update available options in the group based on current selection
	updateAvailableOptions(group) {
		const groupName = group.getAttribute("data-group-name");
		const optionItems = group.querySelectorAll("li[data-option]");
		optionItems.forEach((item) => {
			const { value } = item.dataset;
			const inputField = item.querySelector("input");
			// Determine if the option is available based on previous selections
			const isAvailable = this.isOptionAvailable({ ...this.selectedOptions, [groupName]: value });
			if (!isAvailable) {
				item.style.display = "none"; // hide if not exist for the previously selected group option
			} else if (!isAvailable.hasAvailable) {
				item.style.display = "block";
				inputField.setAttribute("data-out-of-stock", "true");
			} else {
				item.style.display = "block";
				inputField.removeAttribute("data-out-of-stock");
			}
		});
	}

	// Automatically select the first available option in the group
	autoSelectFirstAvailable(group) {
		const availableOptions = group.querySelectorAll(
			'li[data-option]:not([style*="display: none"]) input[type="radio"]'
		);

		if (availableOptions.length > 0) {
			availableOptions[0].checked = true; // Automatically select the first available option
			const optionName = availableOptions[0].getAttribute("data-option-name");
			const optionValue = availableOptions[0].value;

			// Update the selected options for the auto-selected value
			this.selectedOptions[optionName] = optionValue;
			this.addOptionValueToOptionTitle(optionName, optionValue);
			// Reset and update lower levels after changing the higher-level option
			this.resetLowerOptions(optionName);
			// Show the next group of options based on current selection
			this.showNextOptionGroup();
			this.matchVariant();
		}
	}

	addOptionValueToOptionTitle(optionName, optionValue) {
		const optionGroups = Array.from(this.variantOptionsForm.querySelectorAll("li[data-group-name]"));
		const optGroup = optionGroups.find((group) => group.getAttribute("data-group-name") === optionName);
		if (!optGroup) return;
		const shouldReplace = optGroup.querySelector("[data-group-replace]");
		if (!shouldReplace) return;
		const replaceValue = shouldReplace.getAttribute("data-group-replace");
		// true: replace with option value, false: don't replace, other: use other
		if (!replaceValue || replaceValue === "false") return;
		shouldReplace.innerText = replaceValue === "true" ? optionValue : replaceValue;
	}

	// prepare and get available variantes from form 2 (control form)
	getAvailableVariants() {
		const optionInputs = Array.from(this.variantInputs);
		return optionInputs.map((opt) => ({
			id: opt.value,
			available: opt.dataset.variantAvailable === "true",
			optionSelected: JSON.parse(opt.dataset.variantSelectedOptions),
		}));
	}

	// Check if option is available for some previously selected option
	isOptionAvailable(params = {}) {
		const variantOptions = this.getAvailableVariants();
		const result = variantOptions.filter((variant) =>
			Object.entries(params).every(([paramName, paramValue]) =>
				variant.optionSelected.some((option) => option.name === paramName && option.value === paramValue)
			)
		);

		if (result.length === 0) return false;

		const hasAvailable = result.some((res) => res.available);
		return { hasAvailable };
	}

	checkInputSelected() {
		this.variantInputs.forEach((variantInput) => {
			if (variantInput.value === this.selectedVariant) {
				variantInput.checked = true;
			} else {
				variantInput.checked = false;
			}
		});
	}

	// Match the selected options with a variant in form 2 (control form)
	matchVariant() {
		this.selectedVariant = null; // Reset previously selected variant

		this.variantInputs.forEach((variantInput) => {
			const variantOptions = JSON.parse(variantInput.getAttribute("data-variant-selected-options"));

			const allOptionsMatch =
				variantOptions.length === Object.keys(this.selectedOptions).length &&
				Object.keys(this.selectedOptions).every((optionName) =>
					variantOptions.some(
						(option) => option.name === optionName && option.value === this.selectedOptions[optionName]
					)
				);
			if (allOptionsMatch) {
				// we have a variant selected
				const available = variantInput.getAttribute("data-variant-available");
				this.selectedVariant = variantInput.value; // Assign matching variant value
				this.clearSelectedPot();
				if (available === "true") {
					this.matchVariantAvailableActions();
				} else {
					this.matchVariantOOSActions();
				}
			}
		});
		console.log("Selected variant:", this.selectedVariant);

		if (!this.selectedVariant) {
			console.log("No matching variant found for the selected options.");
		}
	}

	matchVariantAvailableActions() {
		this.potSelectorContainer?.removeAttribute("hidden");
		this.addToBagBtn?.removeAttribute("hidden");
		this.addToBagBtn?.removeAttribute("disabled");
		this.displayVariantRelatedElements();
		this.checkInputSelected();
		this.toggleBackToStockForm(false);
		this.setupGiftVoucherForm(true);
		this.sendPDPEvents("variant-selected");
	}

	matchVariantOOSActions() {
		this.potSelectorContainer?.setAttribute("hidden", "hidden");
		this.addToBagBtn?.setAttribute("hidden", "hidden");
		this.displayVariantRelatedElements();
		this.checkInputSelected();
		this.toggleBackToStockForm(true);
		this.setupGiftVoucherForm(false);
		this.sendPDPEvents("variant-oos");
		console.log("Variant out of stock");
	}

	toggleBackToStockForm(show) {
		const messageWrapper = this.backToStockContainer.querySelector("[data-back-in-stock-date]");
		const dueIn = messageWrapper.getAttribute("data-back-in-stock-date");
		const title = messageWrapper.getAttribute("data-back-in-stock-title");

		let msg = `${title} is sold out but will be back soon - <b>add your email address</b> and we’ll keep you posted.`;
		if (dueIn !== "") {
			msg = `We're stocking ${title} from <b>${dueIn} - add your email address</b> and we’ll keep you posted.`;
		}

		messageWrapper.querySelector("span").innerHTML = msg;

		this.backToStockContainer.classList.toggle("hidden", !show);
		this.backToStockContainer.querySelector("[data-form-wrapper]").classList.remove("hidden");
		this.backToStockContainer.querySelector("[data-form-success]").classList.add("hidden");
		this.backToStockContainer.querySelector("[data-form-error]").classList.add("hidden");
		if (show) {
			// hide other components
			const addosContainers = Array.from(document.querySelectorAll("[data-adds-container]"));
			const potSelectorContainer = document.getElementById("pot-selector-container");
			addosContainers.forEach((addCont) => addCont?.setAttribute("hidden", "hidden"));
			if (potSelectorContainer) potSelectorContainer.setAttribute("hidden", "hidden");
			this.addToBagBtn?.setAttribute("hidden", "hidden");
		}
	}

	async handleBackToStock(e) {
		e.preventDefault();
		const email = e.target.querySelector("[name=ue]").value;

		const formWrapper = this.backToStockContainer.querySelector("[data-form-wrapper]");
		const formSuccess = this.backToStockContainer.querySelector("[data-form-success]");
		const formError = this.backToStockContainer.querySelector("[data-form-error]");

		const variants = this.selectedVariant
			? [
					{
						epi: Number(this.selectedVariant.replace(/\D+/g, "")),
						empi: Number(this.productId.replace(/\D+/g, "")),
						du: window.location.href,
					},
			  ]
			: this.variantInputs.map((vi) => ({
					epi: Number(vi.value.replace(/\D+/g, "")),
					empi: Number(this.productId.replace(/\D+/g, "")),
					du: window.location.href,
			  }));

		const request = await this.asyncRequest({
			url: `${this.apiUrl}/marketing`,
			headers: { "Content-Type": "application/json;charset=UTF-8" },
			method: "POST",
			data: JSON.stringify({
				endpoint: "swym-back-in-stock",
				site: this.siteId,
				params: {
					products: JSON.stringify(variants),
					medium: "email",
					mediumvalue: email,
					topics: '["backinstock"]',
				},
			}),
		});

		formWrapper.classList.add("hidden");

		if (!request || request.status !== 200) {
			formError.classList.remove("hidden");
			return;
		}

		const { status } = JSON.parse(request.response);
		if (status !== 200) {
			formError.classList.remove("hidden");
		} else {
			formSuccess.classList.remove("hidden");
		}
	}

	// select variant using query params
	checkSelectedVariantUrlParams() {
		const params = new URL(document.location).searchParams;
		if (params.size === 0) return;

		const variantSku = params.get("v");
		if (!variantSku) return;

		const variantMatchInput = Array.from(this.variantInputs).find(
			(variant) => variant.getAttribute("data-sku").toUpperCase() === variantSku.trim().toUpperCase()
		);

		if (!variantMatchInput) return;
		const selectedOptions = JSON.parse(variantMatchInput.getAttribute("data-variant-selected-options"));

		const optionInputs = Array.from(this.variantOptionsForm.querySelectorAll('input[type="radio"]'));

		selectedOptions.forEach((opt) => {
			this.selectedOptions[opt.name] = opt.value;
			this.addOptionValueToOptionTitle(opt.name, opt.value);
			this.resetLowerOptions(opt.name);
			const optionButton = optionInputs.find(
				(input) => input.getAttribute("data-option-name") === opt.name && input.value === opt.value
			);
			if (optionButton) optionButton.setAttribute("checked", true);
		});

		this.showNextOptionGroup();
		this.matchVariant();
	}

	// [END] variant select functions

	// [START] Submit functions

	updateButtonText() {
		if (!this.addToBagBtn) return;
		let buttonText;
		if (!this.productType === "plant") {
			buttonText = "Add to bag";
		} else if (this.selectedPot === "none" && this.addOns.length === 0) {
			buttonText = "Add plant to bag";
		} else if (this.selectedPot !== "none" && this.addOns.length === 0) {
			buttonText = "Add plant and pot to bag";
		} else if (this.selectedPot === "none" && this.addOns.length > 0) {
			buttonText = `Add plant and add on${this.addOns.length > 1 ? "s" : ""} to bag`;
		} else if (this.selectedPot !== "none" && this.addOns.length > 0) {
			buttonText = "Add selected items to bag";
		}
		this.addToBagBtn.innerText = buttonText;
	}

	preparePayload() {
		const giftProperties = this.getGiftProperties();

		if (giftProperties && !giftProperties.find((item) => item.key === "Recipient email")) {
			const gitfEmailEl = this.giftVoucherFormContainer.querySelector(".recipient-email");
			gitfEmailEl.classList.add("border-warning");
			return false;
		}

		const primaryItem = {
			merchandiseId: this.selectedVariant,
			quantity: 1,
			...(giftProperties && { attributes: giftProperties }),
		};

		const potItem = this.selectedPot !== "none" && { merchandiseId: this.selectedPot, quantity: 1 };
		const addOnItems =
			this.addOns.length > 0 &&
			this.addOns.map((addOn) => ({
				merchandiseId: addOn,
				quantity: 1,
			}));

		return [primaryItem, potItem, ...(Array.isArray(addOnItems) ? addOnItems : [])].filter(Boolean);
	}

	getGiftProperties() {
		if (!this.giftVoucherFormContainer) return false;
		const sendAsGiftCb = this.giftVoucherFormContainer.querySelector("#send_as_gift");
		if (!sendAsGiftCb.checked) return false;

		const fields = Array.from(this.giftVoucherFormContainer.querySelectorAll(["input", "textarea"]));
		const fieldMap = {
			send_as_gift: "__shopify_send_gift_card_to_recipient",
			recipient_email: "Recipient email",
			recipient_name: "Recipient name",
			message: "Message",
			send_on: "Send on",
		};

		const attributes = [
			{
				key: "__shopify_offset",
				value: "0",
			},
		];

		attributes.push(
			...fields
				.filter((field) => field.value !== "")
				.map((field) => ({ key: fieldMap[field.name], value: field.value }))
		);

		return attributes;
	}

	async handleAddToBag(e) {
		const payload = this.preparePayload();
		if (payload) await super.addToCart(e, payload);
	}

	// [END] Submit functions

	// [START] updates media list order when selected variants

	handleProductMediaContainer() {
		if (!this.productMediaContainer) return;
		const controllers = document.querySelectorAll(`[aria-controls="${this.productMediaContainer.id}"]`);
		controllers.forEach((controller) => {
			controller.addEventListener("click", this.toggleProductMediaContainer.bind(this));
		});
	}

	toggleProductMediaContainer() {
		const isExpanded = this.productMediaContainer.getAttribute("aria-expanded") === "true";
		this.productMediaContainer.setAttribute("aria-expanded", `${!isExpanded}`);
	}

	updateProductMediaContainer() {
		if (this.numberOFVariants <= 1) return;
		const allMedia = Array.from(this.productMediaContainer.querySelectorAll(".relative"));
		const allMediaMob = Array.from(this.productMediaContainerCarousel.querySelectorAll("a"));
		const showMoreBtn = this.productMediaContainer.querySelector(".show-more-media");

		allMedia.sort(this.compareMedia.bind(this)).forEach((node) => this.productMediaContainer.appendChild(node));
		allMediaMob
			.sort(this.compareMedia.bind(this))
			.forEach((node) => this.productMediaContainerCarousel.appendChild(node));

		if (showMoreBtn) this.productMediaContainer.appendChild(showMoreBtn); // move back to botton

		try {
			window.refreshFsLightbox();
		} catch (error) {
			console.error(error);
		}
	}

	compareMedia(a, b) {
		let aImage;
		let bImage;
		if (a.firstElementChild.nodeName === "IMG" || a.firstElementChild.nodeName === "IFRAME") {
			// mobile carousel
			aImage = a.firstElementChild;
			bImage = b.firstElementChild;
		} else {
			// desktop
			aImage = a.firstChild.firstElementChild;
			bImage = b.firstChild.firstElementChild;
		}

		// Check if nodes are IMG elements
		if (aImage.nodeName !== "IMG") return 1;
		if (bImage.nodeName !== "IMG") return -1;

		const aVariant = aImage.getAttribute("data-variant-priority");
		const bVariant = bImage.getAttribute("data-variant-priority");
		const aIndex = parseInt(aImage.getAttribute("data-variant-image-index"), 10);
		const bIndex = parseInt(bImage.getAttribute("data-variant-image-index"), 10);

		// Prioritize elements with matching `data-variant-priority`
		if (aVariant === this.selectedVariant && bVariant !== this.selectedVariant) return -1;
		if (bVariant === this.selectedVariant && aVariant !== this.selectedVariant) return 1;

		// If both or neither match, compare by `data-variant-image-index`
		if (aIndex < bIndex) return -1;
		if (aIndex > bIndex) return 1;

		// If all else is equal, maintain current order
		return 0;
	}

	// [END] updates media list order when selected variants

	displayVariantRelatedElements() {
		let hasPots = false;

		// reorder images by variant
		this.updateProductMediaContainer();

		// Show all related elements to selected variant
		this.variantElements.forEach((ele) => {
			const relatedVariant = ele.getAttribute("data-variant");
			const isActiveVariant = relatedVariant === this.selectedVariant;
			ele.toggleAttribute("hidden", !isActiveVariant);

			if (isActiveVariant && ele.closest("#pot-selector-container")) {
				hasPots = true;
			}
		});

		if (this.potSelectorContainer) {
			if (hasPots) {
				// when variant is selected, hide/show some elements
				this.potSelectorContainer.removeAttribute("hidden");
				this.potSelectorContainer.setAttribute("data-variant-selected", "true");
			} else {
				this.potSelectorContainer.setAttribute("hidden", "hidden");
			}
		}
	}

	clearSelectedPot() {
		if (!this.selectedPotContainer || !this.potSelectorContainer) return;
		this.selectedPot = "none";
		this.selectedPotContainer.innerHTML = "";
		this.potSelectorContainer.removeAttribute("hidden");
		this.updateButtonText();
	}

	renderSelectedPot() {
		if (!this.selectedPotContainer || !this.potSelectorContainer) return;
		this.selectedPotContainer.innerHTML = "";
		this.potSelectorContainer.setAttribute("hidden", "hidden");

		const selectedPotData = this.getSelectedPotData();

		if (selectedPotData) {
			const selectedPotTemplate = document.getElementById("pot-selected-pot-template");
			const selectedPotNode = selectedPotTemplate.content.cloneNode(true);
			const selectedPotImgEle = selectedPotNode.querySelector("[data-selected-pot-img]");

			const croppedStudioImg = selectedPotData.metafields
				.find((mf) => mf?.key === "variant_images")
				.reference.fields.find((f) => f.key === "cropped_studio_shot");
			const potPrice = selectedPotData.price.amount;
			const potName = selectedPotData.product.title;

			selectedPotImgEle.style.backgroundImage = `url('${croppedStudioImg.reference.image.url}')`;
			const selectedPotPriceEle = selectedPotNode.querySelector("[data-selected-pot-price]");
			selectedPotPriceEle.innerHTML = Core.formatCurrency(potPrice);
			const selectedPotNameEle = selectedPotNode.querySelector("[data-selected-pot-name]");
			selectedPotNameEle.innerHTML = potName;
			this.selectedPotContainer.appendChild(selectedPotNode);
			const removePotButton = this.selectedPotContainer.querySelector("[data-remove-pot]");
			removePotButton.addEventListener("click", () => {
				this.clearSelectedPot();
			});
		} else {
			// No decorative pot
			const notSelectedPotTemplate = document.getElementById("no-pot-selected-template");
			if (!notSelectedPotTemplate) return;
			const selectedPotNode = notSelectedPotTemplate.content.cloneNode(true);
			const selectedPotImgEle = selectedPotNode.querySelector("[data-selected-pot-img]");
			const nurseryImg = this.potSelectorContainer.querySelector(`li[data-variant="${this.selectedVariant}"] img`);
			selectedPotImgEle.src = nurseryImg.src;
			this.selectedPotContainer.appendChild(selectedPotNode);
		}

		const triggerButton = this.selectedPotContainer.querySelector("[data-trigger-pot-selector-modal]");
		triggerButton.addEventListener("click", () => {
			this.potSelectorModal = this.addModal("pot-selector-modal-template", this.clearSelectedPot.bind(this));
			this.handlePotPreview();
			this.showCorrectPotVariants();
			this.addPotSelectorEventListeners();
			this.handleApply();
			this.handleScroll();
		});
	}

	handleScroll() {
		if (!this.potSelectorModal) return;
		const potOptions = this.potSelectorModal.querySelector("#pot-options");

		potOptions.addEventListener("scroll", () => {
			const scroller = this.potSelectorModal.querySelector("[data-scroller]");
			const scrollerSpan = scroller.querySelector("span");

			const { clientWidth, scrollWidth, scrollLeft } = potOptions;
			const { clientWidth: scrollUtil } = scroller;
			const { clientWidth: scrollerWidth } = scrollerSpan;

			const handleSizePorcent = (scrollerWidth / scrollUtil) * 100;
			const pos = ((scrollLeft - scrollerWidth) / (scrollWidth - clientWidth)) * 100;
			scrollerSpan.style.setProperty("--left", `${Math.min(Math.max(pos, 0), 100 - handleSizePorcent)}%`);
		});
	}

	handleApply() {
		if (!this.potSelectorModal) return;
		this.potSelectorModal.querySelectorAll("[data-pot-selector-apply]").forEach((btn) =>
			btn.addEventListener("click", () => {
				this.renderSelectedPot();
				document.body.classList.remove("overflow-hidden");
				this.potSelectorModal.remove();
			})
		);
	}

	handlePotSelectorModalTriggers() {
		document.querySelectorAll("[data-trigger-pot-selector-modal]").forEach((trigger) =>
			trigger.addEventListener("click", () => {
				this.potSelectorModal = this.addModal("pot-selector-modal-template", this.clearSelectedPot.bind(this));
				this.handlePotPreview();
				this.showCorrectPotVariants();
				this.addPotSelectorEventListeners();
				this.handleApply();
				this.handleScroll();
			})
		);
	}

	getSelectedVariantData() {
		const potPreviewData = JSON.parse(
			this.potSelectorModal.querySelector("[data-pot-preview-data]").dataset.potPreviewData
		);
		return potPreviewData.find((product) => product.id === this.selectedVariant) || potPreviewData[0];
	}

	getSelectedPotData() {
		const selectedVariantData = this.getSelectedVariantData();

		const nurseryPotsData = selectedVariantData.metafields.find((mf) => mf.key === "nursery_pots");
		const potVariants = nurseryPotsData.reference.fields.find((f) => f.key === "pot_variants");
		return potVariants.references.nodes.find((n) => n.id === this.selectedPot);
	}

	getPotPreviewImages() {
		const selectedPotData = this.getSelectedPotData();
		const selectedVariantData = this.getSelectedVariantData();

		const selectedVariantVariantImages = selectedVariantData.metafields.find((mf) => mf.key === "variant_images");
		const plantImg = selectedVariantVariantImages.reference.fields.find((f) => f.key === "clear_cut_plant");
		const plantStringsImg = selectedVariantVariantImages.reference.fields.find((f) => f.key === "hanging_pot_strings");

		const selectedPotVariantImages = selectedPotData
			? selectedPotData.metafields.find((mf) => mf?.key === "variant_images")
			: selectedVariantVariantImages;

		const stringsImg = selectedPotVariantImages.reference.fields.find((f) => f.key === "hanging_pot_strings");
		const potImg = selectedPotVariantImages.reference.fields.find((f) => f.key === "clear_cut_pot_with_shadow");

		return {
			plantStringsImg,
			stringsImg,
			plantImg,
			potImg,
		};
	}

	handlePotPreview() {
		const loading = document.getElementById("loading-pot");
		const previewStand = this.potSelectorModal.querySelector("[data-pot-preview-data] > div");
		const plantImgEle = this.potSelectorModal.querySelector("[data-pot-preview-plant]");
		const potImgEle = this.potSelectorModal.querySelector("[data-pot-preview-pot]");
		const stringsImgEle = this.potSelectorModal.querySelector("[data-pot-preview-strings]");
		const surfaceEle = this.potSelectorModal.querySelector("[data-pot-preview-surface]");

		previewStand.style.setProperty("opacity", "0");
		stringsImgEle.classList.add("invisible");
		plantImgEle.classList.add("invisible");
		potImgEle.classList.add("invisible");
		loading.classList.remove("invisible");

		// unselect previous pot
		const allPotSelectButtons = Array.from(this.potSelectorModal.querySelectorAll("[data-select-pot]"));
		const previousSelectedPotButton = allPotSelectButtons.find((btn) => btn.getAttribute("[data-selected]"));
		previousSelectedPotButton?.removeAttribute("data-selected");

		// Check if pot selected is present on set of pots or select the first option
		const allActivePotSelectButtons = Array.from(
			this.potSelectorModal.querySelectorAll(`[data-variant="${this.selectedVariant}"] > li button`)
		);
		const selectedPotButton = allActivePotSelectButtons.find(
			(btn) => btn.getAttribute("data-select-pot") === this.selectedPot
		);
		if (selectedPotButton) {
			selectedPotButton.setAttribute("data-selected", "data-selected");
		} else {
			allActivePotSelectButtons[0].setAttribute("data-selected", "data-selected");
			this.selectedPot = allActivePotSelectButtons[0].getAttribute("data-select-pot");
		}

		// Get images and tweak layout
		const { stringsImg, plantImg, potImg, plantStringsImg } = this.getPotPreviewImages();
		const loadImagesStatus = [plantImgEle, potImgEle];

		plantImgEle.src = plantImg.reference.potImage.url;
		potImgEle.src = potImg.reference.potImage.url;

		surfaceEle.classList.remove("hidden");

		if (stringsImg) {
			stringsImgEle.src = stringsImg.reference.potImage.url;
			surfaceEle.classList.add("hidden");
			surfaceEle.classList.add("!top-[25%]");
			plantImgEle.classList.add("!pt-0");
			if (plantStringsImg) {
				potImgEle.classList.add("!pb-[37%]");
			}

			loadImagesStatus.push(stringsImgEle);
		}

		// Await load images and effects finish
		loadImagesStatus.forEach((item, index) =>
			item.addEventListener(
				"load",
				() => {
					loadImagesStatus[index] = "loaded";
					if (loadImagesStatus.every((s) => s === "loaded")) {
						setTimeout(() => {
							loading.classList.add("invisible");
							if (stringsImg) stringsImgEle.classList.remove("invisible");
							plantImgEle.classList.remove("invisible");
							potImgEle.classList.remove("invisible");
							previewStand.style.setProperty("opacity", "1");
						}, 1000);
					}
				},
				{ once: true }
			)
		);
	}

	showCorrectPotVariants() {
		if (!this.potSelectorModal || !this.selectedVariant) return;
		this.potSelectorModal
			.querySelectorAll(`[data-variant="${this.selectedVariant}"]`)
			.forEach((ele) => ele.removeAttribute("hidden"));
	}

	addPotSelectorEventListeners() {
		if (!this.potSelectorModal) return;
		this.potSelectorModal.querySelectorAll("[data-select-pot]").forEach((ele) => {
			ele.addEventListener("click", () => {
				this.selectPot(ele);
			});
		});
	}

	selectPot(ele) {
		const currentlySelectedPot = document.querySelector(`[data-select-pot="${this.selectedPot}"][data-selected]`);
		if (currentlySelectedPot) currentlySelectedPot.removeAttribute("data-selected");
		this.selectedPot = ele.dataset.selectPot;
		ele.setAttribute("data-selected", "data-selected");
		this.handlePotPreview();
		this.updateButtonText();
	}

	handleAddOns() {
		document.querySelectorAll("[data-add-on]").forEach((btn) => {
			btn.addEventListener("click", ({ target }) => {
				this.toggleAddOn(target);
			});
		});
	}

	toggleAddOn(target) {
		const { addOn } = target.dataset;
		const isSelected = target.toggleAttribute("data-selected");
		this.addOns = this.addOns.filter((item) => item !== addOn);
		if (isSelected) {
			this.addOns.push(addOn);
		}
		this.updateButtonText();
	}
}

// eslint-disable-next-line no-new
const product = new Product();
product.init();
